import axios from 'axios';
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

const UpdateStudio = () => {

    const { urlPath } = useParams();
    const navigate = useNavigate();
    console.log(urlPath, "Urlss")

    const [studioName, setStudioName] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [features, setFeatures] = React.useState('');
    const [isActive, setIsActive] = React.useState(false);
    const [studioPngImage,setStudioPngImage] = React.useState(null);
    const [studioLocation,setStudioLocation] = React.useState("");
    // const [iframeUrl,setIframeUrl] = React.useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(false);



    useEffect(() => {
        axios.get(`https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/studio/${urlPath}`)
        .then((res) => {
            console.log("Studio Data", res.data.data);
            const studioData = res.data.data;
            setStudioName(studioData?.studioName || '');
            setAddress(studioData.address || '');
            setFeatures(studioData.features || '');
            setIsActive(studioData.isActive || false);
            setStudioPngImage(studioData.studioPngImage || null);
            setStudioLocation(studioData.studioLocation || "");
            // setIframeUrl(studioData.iframeUrl || "");
        })
        .catch((err) => {
            console.log("Error fetching studio data", err);
        });
    },[urlPath]);

    const handleUpdateStudio = async () => {
        try {
            setIsSubmitDisabled(true);

            const payload = {};

            if (studioName) payload.studioName = studioName;
            if (address) payload.address = address;
            if (features) payload.features = features;

            // boolean must be checked explicitly
            if (isActive !== undefined) payload.isActive = isActive;

            if (studioPngImage) payload.studioPngImage = studioPngImage;
            if (studioLocation) payload.studioLocation = studioLocation;

            await axios.put(
            `https://us-central1-btay-project-1551779459124.cloudfunctions.net/AY/studio/${encodeURIComponent(urlPath)}`,
            payload
            );

            alert("Studio updated successfully!");
            navigate('/home');
        } catch (error) {
            console.error(error);
            alert("Update failed");
        } finally {
            setIsSubmitDisabled(false);
        }
    };




  return (
     <div className="Apps">
      <div className="breadcrumbcontainer">
        <div className="breadcrumb-nav">
          <img src="/assets/rightchevron.png" alt="" />
          <span>Update Studio</span>
        </div>
      </div>
      <form className="quickread_from" onSubmit={(e) => { e.preventDefault(); handleUpdateStudio(); }}>
        <div className="mb-3">
            <label htmlFor="id" className="form-label">Studio Name<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="studioName"
                value={studioName}
                onChange={e => { setStudioName(e.target.value); }}
            />
        </div>

        <div className="mb-3 d-flex gap-2 align-items-center">
          <input
             type="checkbox"
             id="isActive"
             checked={isActive}
             onChange={(e) => {
               setIsActive(e.target.checked);
             }}
          />
           <label htmlFor="category" className="form-label">
            Is 
            Studio Active
          </label>
        </div>

        <div className="mb-3">
            <label htmlFor="id" className="form-label">Address<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="address"
                value={address}
                onChange={e => { setAddress(e.target.value); }}
            />
        </div>

        <div className="mb-3">
            <label htmlFor="id" className="form-label">Features<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="features"
                value={features}
                onChange={e => { setFeatures(e.target.value); }}
            />
        </div>

        <div className="mb-3">
            <label htmlFor="id" className="form-label">Studio Image<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="studioPngImage"
                value={studioPngImage}
                onChange={e => { setStudioPngImage(e.target.value); }}
            />
        </div>

        <div className="mb-3">
            <label htmlFor="id" className="form-label">Studio Location<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="studioLocation"
                value={studioLocation}
                onChange={e => { setStudioLocation(e.target.value); }}
            />
        </div>

        {/* <div className="mb-3">
            <label htmlFor="id" className="form-label">Iframe Map URL<span className="required">*</span></label>
            <input
                type="text"
                className="form-control"
                id="iframeUrl"
                value={iframeUrl}
                onChange={e => { setIframeUrl(e.target.value); }}
            />
        </div> */}

        <input
          disabled={isSubmitDisabled}
          className="submitBtn"
          type="submit"
          value="Submit"
        />

        </form>
    </div>
        
  )
}

export default UpdateStudio